"use strict";
// _partialFile.js

{
  const recruitColumns = document.querySelectorAll(".p-recruit__column");
  let ticking = false;

  function updateRecruit() {
    const scrollY = window.scrollY;

    recruitColumns.forEach((column) => {
      const track = column.querySelector(".p-recruit__track");
      if (!track) return;

      const speed = parseFloat(column.dataset.speed || 0.2);
      const trackHeight = track.scrollHeight / 2; // 6枚出力しているので 3枚分で1ループ想定
      if (!trackHeight) return;

      let offset = (scrollY * speed) % trackHeight;
      if (offset > 0) offset -= trackHeight; // 上下方向双方で循環させる
      track.style.transform = `translate3d(0, ${offset}px, 0)`;
    });

    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(updateRecruit);
      ticking = true;
    }
  }

  if (recruitColumns.length) {
    updateRecruit();
    window.addEventListener("scroll", onScroll, { passive: true });
  }
}
